import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { CheckboxListComponent } from "@components/checkbox-list/checkbox-list.component";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { chain } from "lodash";
import { Observable, of } from "rxjs";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-tillganglighet-filter",
    templateUrl: "./tpl-tillganglighet-filter.component.html",
    styleUrls: ["./tpl-tillganglighet-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        CheckboxListComponent
    ]
})
export class TplTillganglighetFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {

    @Input() dataSource: ITplArbetsorder[];

    options: Observable<string[]>;

    constructor() {
        super("tillganglighetVag");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    onFilterInit(state: string[]): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    match(item: ITplArbetsorder): boolean {
        return this.value().indexOf(item.tillganglighetVag) > -1;
    }

    value(): string[] {
        return this.control.value;
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: string[]): void {
        this.filterLength = !value ? 0 : value.length;
    }

    private initOptions(): void {
        const options = chain(this.dataSource)
            .filter(x => !!x.tillganglighetVag)
            .map(x => x.tillganglighetVag)
            .uniq()
            .orderBy()
            .value();
        this.options = of(options);
    }
}
